import { Link } from "react-router-dom";
import { navLinks, siteInfo } from "@/mocks/site";

export default function NotFound() {
  return (
    <section className="mx-auto flex w-full flex-col items-center px-4 py-20 text-center md:px-8 md:py-28">
      <span className="flex h-16 w-16 items-center justify-center rounded-full bg-secondary-100 text-secondary-800">
        <i className="ri-emotion-laugh-line text-3xl"></i>
      </span>
      <p className="mt-6 font-heading text-6xl text-primary-500 md:text-8xl">404</p>
      <h1 className="mt-4 font-heading text-2xl text-foreground-950 md:text-3xl">这一页好像溜走了</h1>
      <p className="mt-3 max-w-md text-sm leading-relaxed text-foreground-600">
        你要找的内容可能已经被移动或下架。别急着走，从下面挑个方向接着逛吧。
      </p>

      <div className="mt-8 flex flex-wrap justify-center gap-2">
        {navLinks.map((item) => (
          <Link
            key={item.path}
            to={item.path}
            className="rounded-full border border-background-300 bg-background-50 px-4 py-2 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
          >
            {item.label}
          </Link>
        ))}
      </div>

      <Link
        to="/"
        className="mt-8 inline-flex whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm text-background-50 transition-colors hover:bg-primary-600"
      >
        回到 {siteInfo.name} 首页
      </Link>
    </section>
  );
}